import React from 'react';
import { SupplierInfo } from '../types/supplierInfo.types';
import { SaveIcon } from '@/shared/components/icons/Icons';

interface BusinessInfoSectionProps {
    supplierInfo: SupplierInfo;
    saving: boolean;
    onFieldChange: (field: keyof SupplierInfo, value: string) => void;
    onSave: () => void;
}

const BusinessInfoSection: React.FC<BusinessInfoSectionProps> = ({
                                                                     supplierInfo,
                                                                     saving,
                                                                     onFieldChange,
                                                                     onSave
                                                                 }) => {
    return (
        <div className="detail-card">
            <div className="detail-card-header">
                <i className="fas fa-briefcase card-icon" />
                <h3 className="card-title">사업자 정보</h3>
            </div>

            <div className="info-table">
                <div className="info-row">
                    <div className="info-label">법인명</div>
                    <div className="info-value">
                        <input
                            type="text"
                            value={supplierInfo.companyName}
                            onChange={(e) => onFieldChange('companyName', e.target.value)}
                        />
                    </div>
                    <div className="info-label">사업자등록번호</div>
                    <div className="info-value">
                        <input
                            type="text"
                            value={supplierInfo.businessNumber}
                            onChange={(e) => onFieldChange('businessNumber', e.target.value)}
                            placeholder="0000000000"
                        />
                    </div>
                </div>

                <div className="info-row">
                    <div className="info-label">대표자명</div>
                    <div className="info-value">
                        <input
                            type="text"
                            value={supplierInfo.representative}
                            onChange={(e) => onFieldChange('representative', e.target.value)}
                        />
                    </div>
                    <div className="info-label">업태</div>
                    <div className="info-value">
                        <input
                            type="text"
                            value={supplierInfo.bizType}
                            onChange={(e) => onFieldChange('bizType', e.target.value)}
                        />
                    </div>
                </div>

                <div className="info-row">
                    <div className="info-label">종목</div>
                    <div className="info-value">
                        <input
                            type="text"
                            value={supplierInfo.bizItem}
                            onChange={(e) => onFieldChange('bizItem', e.target.value)}
                        />
                    </div>
                    <div className="info-label">사업자종류</div>
                    <div className="info-value">
                        <select
                            value={supplierInfo.bizClass}
                            onChange={(e) => onFieldChange('bizClass', e.target.value)}
                        >
                            <option value="">선택</option>
                            <option value="일반">일반</option>
                            <option value="법인">법인</option>
                        </select>
                    </div>
                </div>

                <div className="info-row">
                    <div className="info-label">과세자</div>
                    <div className="info-value">
                        <select
                            value={supplierInfo.taxType}
                            onChange={(e) => onFieldChange('taxType', e.target.value)}
                        >
                            <option value="">선택</option>
                            <option value="GENERAL">일반과세자</option>
                            <option value="SIMPLIFIED">간이과세자</option>
                            <option value="EXEMPT">면세사업자</option>
                        </select>
                    </div>
                    <div className="info-label"></div>
                    <div className="info-value"></div>
                </div>
            </div>

            <div className="section-actions">
                <button className="save-btn" onClick={onSave} disabled={saving}>
                    <SaveIcon width={16} height={16} />
                    <span>{saving ? '저장 중...' : '저장'}</span>
                </button>
            </div>
        </div>
    );
};

export default BusinessInfoSection;
